
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otp-request",
      function () {
        return require("private-next-pages/otp-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/otp-request"])
      });
    }
  